import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuizzesTab } from '@/views/admin/courses/tabs/quizzes-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/quizzes')({
  component: QuizzesRoute,
});

function QuizzesRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/quizzes' });
  return <QuizzesTab id={id} />;
}
